import React, { useEffect, useState } from "react";
import "./../Header/Header.css";
import { Link } from "react-router-dom";
import { BsFacebook, BsTwitter, BsLinkedin, BsInstagram } from "react-icons/bs";
import { MdLocationPin, MdLocalPhone } from "react-icons/md";
import { RxCross1 } from "react-icons/rx";
import { AiOutlineBars } from "react-icons/ai";
import { HashLink } from "react-router-hash-link";
import { SlEnvelopeOpen } from "react-icons/sl";
import apiClient from "../../Config/apiConfig";
const config = {
  BASE_URL: "https://admin.thezeeshangroup.com/",
};
const Header = () => {
  const [getSiteDetails, setGetSiteDetails] = useState([]);
  const sitedetailsApi = async () => {
    try {
      const res = await apiClient.get(`api/sitedetails`);
      setGetSiteDetails(res.data);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    sitedetailsApi();
  }, []);
  return (
    <>
      <div className="site-mobile-menu site-navbar-target">
        <div className="site-mobile-menu-header">
          <div className="site-mobile-menu-close mt-3">
            <span className="icon-close2 js-menu-toggle">
              <RxCross1 />
            </span>
          </div>
        </div>
        <div className="site-mobile-menu-body"></div>
      </div>
      {getSiteDetails && (
        <div className="site-navbar-wrap">
          <div className="site-navbar-top">
            <div className="container py-2">
              <div className="row align-items-center">
                <div className="col-9 top-left-bar">
                  <div className="d-flex mr-auto">
                    <Link href="#" className="d-flex align-items-center mr-4">
                      <MdLocationPin />
                      <span className="d-none d-md-inline-block">
                        {getSiteDetails.address}
                      </span>
                    </Link>
                    <Link
                      to={`tel:${getSiteDetails.phone}`}
                      className="d-flex align-items-center mr-auto"
                    >
                      <MdLocalPhone />
                      <span className="d-none d-md-inline-block">
                        +91 {getSiteDetails.phone}
                      </span>
                    </Link>
                    <Link
                      to={`mailto:${getSiteDetails.email}`}
                      className="d-flex align-items-center mr-auto"
                    >
                      <SlEnvelopeOpen />
                      <span className="d-none d-md-inline-block">
                        {getSiteDetails.email}
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="col-3 text-right">
                  <div className="mr-auto">
                    <Link
                      to={getSiteDetails.facebook_link}
                      className="p-2 pl-0"
                      target="_blank"
                    >
                      <BsFacebook />
                    </Link>
                    <Link
                      to={getSiteDetails.twitter_link}
                      className="p-2 pl-0"
                      target="_blank"
                    >
                      <BsTwitter />
                    </Link>
                    <Link
                      to={getSiteDetails.linkedin_link}
                      className="p-2 pl-0"
                      target="_blank"
                    >
                      <BsLinkedin />
                    </Link>
                    <Link
                      to={getSiteDetails.instagram_link}
                      className="p-2 pl-0"
                      target="_blank"
                    >
                      <BsInstagram />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="site-navbar site-navbar-target js-sticky-header">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-2 main-logo">
                  <h1 className="my-0 site-logo">
                    <Link to="/">
                      <img src={`${config.BASE_URL}uploads/${getSiteDetails.logo}`} alt="" />
                    </Link>
                  </h1>
                </div>
                <div className="col-10">
                  <nav className="site-navigation text-right" role="navigation">
                    <div className="container">
                      <div className="d-inline-block d-lg-none ml-md-0 mr-auto py-3">
                        <Link
                          href="#"
                          className="site-menu-toggle js-menu-toggle text-white"
                        >
                          <span className="icon-menu h3">
                            <AiOutlineBars />
                          </span>
                        </Link>
                      </div>
                      <ul className="site-menu main-menu js-clone-nav d-none d-lg-block">
                        <li className="active">
                          <Link to="/" className="nav-link">
                            Home
                          </Link>
                        </li>
                        <li className="has-children">
                          <Link href="#" className="nav-link">
                            About Us
                          </Link>
                          <ul className="dropdown arrow-top">
                            <li>
                              <Link to="/about-us" className="nav-link">
                                Zeeshan Group
                              </Link>
                            </li>
                            <li>
                              <HashLink
                                smooth
                                to="/about-us/#chairman&md"
                                className="nav-link"
                              >
                                CHAIRMAN & MD
                              </HashLink>
                            </li>
                            <li>
                              <HashLink
                                smooth
                                to="/about-us/#operation-head"
                                className="nav-link"
                              >
                                OPERATION HEAD
                              </HashLink>
                            </li>
                            <li>
                              <HashLink
                                smooth
                                to="/about-us/#ceo"
                                className="nav-link"
                              >
                                CEO
                              </HashLink>
                            </li>
                            <li>
                              <HashLink
                                smooth
                                to="/about-us/#construction-incgarge"
                                className="nav-link"
                              >
                                CONSTRUCTION INCHARGE
                              </HashLink>
                            </li>
                          </ul>
                        </li>
                        {/* <li>
                        <Link to="/about-us" className="nav-link">
                          About Us
                        </Link>
                      </li> */}
                        <li className="has-children">
                          <Link href="#" className="nav-link">
                            QHSE
                          </Link>
                          <ul className="dropdown arrow-top">
                            <li>
                              <Link to="/coming-soon" className="nav-link">
                                CSR (corporate Social Responsibility)
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/quality-health-safety-and-environment"
                                className="nav-link"
                              >
                                Quality,Health, Safety,and Environment
                              </Link>
                            </li>
                          </ul>
                        </li>
                        {/* <li>
                        <Link to="/qhse" className="nav-link">
                          QHSE
                        </Link>
                      </li> */}
                        <li className="has-children">
                          <Link href="#" className="nav-link">
                            Operating Division
                          </Link>
                          <ul className="dropdown arrow-top">
                            <li>
                              <HashLink
                                smooth
                                to="/#zeeshanconstruction"
                                className="nav-link"
                              >
                                Zeeshan Construction
                              </HashLink>
                            </li>

                            <li>
                              <Link
                                to="/property/galaxia-dreams"
                                className="nav-link"
                              >
                                Zaira and Zeeshan Construction
                              </Link>
                            </li>
                            <li>
                              <Link to="/coming-soon" className="nav-link">
                                Zaira and Zeeshan Trader
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li className="has-children">
                          <Link href="#" className="nav-link">
                            Clients
                          </Link>
                          <ul className="dropdown arrow-top">
                            <li>
                              <Link to="/clients" className="nav-link">
                                Clients
                              </Link>
                            </li>
                            <li>
                              <Link to="/testimonials" className="nav-link">
                                Testimonials
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <Link to="/career" className="nav-link">
                            Career
                          </Link>
                        </li>
                        <li>
                          <Link to="/contact-us" className="nav-link">
                            Contact Us
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
